"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAPIKeyDto = void 0;
class UpdateAPIKeyDto {
    title;
    isArchived;
    expireAt;
    permissions;
    limitReqsPerDay;
    hooks;
}
exports.UpdateAPIKeyDto = UpdateAPIKeyDto;
